import { Typography, Stepper, Step, StepLabel } from '@mui/material';
import { parseISO, differenceInDays } from 'date-fns';
import utils from '../../../utils/utils';
import StepConnector, {
    stepConnectorClasses,
} from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import { styled } from '@mui/material/styles';
import Check from '@mui/icons-material/Check';

const steps = (info) => [
    {
        label: 'Registration',
        field: info.registrationDate,
    },
    {
        label: 'Diagnostics Start',
        field: info.diagnosticsStartDate,
    },
    {
        label: 'Diagnosis',
        field: info.diagnosisDate,
    },
    {
        label: 'Treatment Procedure Start',
        field: info.treatmentProcedureStartDate,
    },
    {
        label: 'Drug Treatment Start',
        field: info.drugTreatmentStartDate,
    },
    {
        label: 'Treatment Procedure Finish',
        field: info.treatmentProcedureFinishDate,
    },
    {
        label: 'Drug Treatment Finish',
        field: info.drugTreatmentFinishDate,
    },
    {
        label: 'Date of Death',
        field: info.dateOfDeath,
    },
];

const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#325599',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#325599',
        },
    },
    [`&.${stepConnectorClasses.disabled}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#eaeaf0',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#eaeaf0',
        borderTopWidth: 2,
        borderRadius: 1,
        ...theme.applyStyles('dark', {
            borderColor: theme.palette.grey[800],
        }),
    },
}));

const QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(
    ({ theme }) => ({
        color: '#eaeaf0',
        display: 'flex',
        height: 22,
        alignItems: 'center',
        '& .QontoStepIcon-completedIcon': {
            color: '#325599',
            zIndex: 1,
            fontSize: 18,
        },
        '& .QontoStepIcon-circle': {
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: '#eaeaf0',
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[700],
        }),
        variants: [
            {
                props: ({ ownerState }) => ownerState.active,
                style: {
                    color: '#325599',
                },
            },
        ],
    })
);

function QontoStepIcon(props: StepIconProps) {
    const { active, completed, className } = props;

    return (
        <QontoStepIconRoot ownerState={{ active }} className={className}>
            {completed ? (
                <Check className="QontoStepIcon-completedIcon" />
            ) : (
                <div className="QontoStepIcon-circle" />
            )}
        </QontoStepIconRoot>
    );
}

const formatDateField = (value) => {
    if (Array.isArray(value) && value.length === 3) {
        const [year, month, day] = value;
        return {
            formattedDate: utils.formatDate([year, month - 1, day], 'L'),
            dateObject: new Date(year, month - 1, day),
        };
    }
    return {
        formattedDate: utils.formatDate(value, 'L'),
        dateObject: parseISO(value),
    };
};

const isDateInMilliseconds = (value) => {
    return typeof value === 'number' && value.toString().length === 13;
};

const calculateDaysAgo = (dateValue: any) => {
    if (isDateInMilliseconds(dateValue)) {
        dateValue = new Date(dateValue);
    } else {
        dateValue = parseISO(dateValue);
    }
    const today = new Date();
    return differenceInDays(today, dateValue);
};

export const Timeline = ({ info, ...props }) => (
    <div>
        <Stepper
            alternativeLabel
            activeStep={steps(info).filter((step) => step.field).length - 1}
            style={{ background: 'transparent' }}
            connector={<QontoConnector />}
        >
            {steps(info).map((step, idx) => (
                <Step
                    key={`step-${idx}`}
                    completed={step.field}
                    disabled={!step.field}
                >
                    <StepLabel StepIconComponent={QontoStepIcon}>
                        <Typography
                            variant="caption"
                            style={{ fontSize: '0.7em', fontWeight: 'bold' }}
                            color={'primary'}
                        >
                            {step.label}
                        </Typography>
                        <Typography style={{ fontSize: '1em' }}>
                            {step.field
                                ? formatDateField(step.field).formattedDate
                                : 'N/A'}
                        </Typography>
                        {step.field && (
                            <Typography
                                style={{
                                    fontSize: '0.75em',
                                }}
                                color={'primary'}
                            >
                                ({`${calculateDaysAgo(step.field)} days ago`})
                            </Typography>
                        )}
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    </div>
);
